<script>
import axios from "axios";
import router from "@/router";
/*import logoutButton from './logout-button';*/
import Header from '@/components/front/Header';
import Footer from '@/components/front/Footer';

import {
  required
} from "vuelidate/lib/validators";

export default {
  page: {
    title: "Volunteer System",
    meta: [
      {
        name: "Volunteer System",
      },
    ],
  },
  components: { /*logoutButton ,*/ Header , Footer },
  data(){
    return{
      title: "",
      items: [
        {
          text: "",
          href: "/",
        },
      ],
      backToOverview: false,
      userData: JSON.parse(localStorage.getItem('web_user')),
      addEmploymentForm: {
        employer: "",
        city: "",
        state: "",
        user_type_id : ""
      },
      typeSubmit:false
    }
  },
  validations: {
    addEmploymentForm: {
      employer: { required },
      city: { required },
      state: { required },
    },
  },
  mounted(){
    this.getEmployment();
    this.getSubmitFormStats();
  },
  methods: {

    skipToReview() {
      router.push({ name: 'review-application'})
    },

    references() {
      router.push({ name: 'references'})
    },
    
    // Getting Current User Forms States
    getSubmitFormStats() {
      let formCompleted = true;
      var userData = JSON.parse(localStorage.getItem('web_user'));
      var config = {
        headers: { Authorization: 'Bearer ' + userData['token'] },
      };
      if (userData.token) {
        axios
          .get(
            'user/registration/submitted-forms?user_type_id=' +
              userData['user_type_id'],
            config
          )
          .then((res) => {
            // Mentor
            if( userData['user_type_id'] == 3 ) {
              if (res.data.response.additional_details === false) {
                formCompleted = false;
              }
              if (res.data.response.background === false) {
                formCompleted = false;
              }
              if (res.data.response.faith === false) {
                formCompleted = false;
              }
              if (res.data.response.personal_info === false) {
                formCompleted = false;
              }
              if (res.data.response.question === false) {
                formCompleted = false;
              }
              if (res.data.response.reference === false) {
                formCompleted = false;
              }
            } else {
              if( userData.is_mentor ) {
                // Mentor/Volunteer
                if (res.data.response.additional_details === false) {
                  formCompleted = false;
                }
                if (res.data.response.background === false) {
                  formCompleted = false;
                }
                if (res.data.response.faith === false) {
                  formCompleted = false;
                }
                if (res.data.response.personal_info === false) {
                  formCompleted = false;
                }
                if (res.data.response.question === false) {
                  formCompleted = false;
                }
                if (res.data.response.reference === false) {
                  formCompleted = false;
                }
                if (res.data.response.opportunity === false) {
                  formCompleted = false;
                }
              } else {
                // Volunteer
                if (res.data.response.additional_details === false) {
                  formCompleted = false;
                }
                if (res.data.response.faith === false) {
                  formCompleted = false;
                }
                if (res.data.response.opportunity === false) {
                  formCompleted = false;
                }
                if (res.data.response.personal_info === false) {
                  formCompleted = false;
                }
                if (res.data.response.question === false) {
                  formCompleted = false;
                }
              }
              
            }
            
            if( !formCompleted ) {
              this.backToOverview = false;
            } else {
              this.backToOverview = true;
            }
          })
          .catch((err) => {
            if (err.response) {
              console.log(err.response.data.error.message);
            }
          });
      }
    },

    // Adding Employment Form
    addEmployment() {
      this.typeSubmit = true;
      this.$v.$touch()
      if(!this.$v.$invalid){
        var userData = JSON.parse(localStorage.getItem('web_user'));
        var config = {
          headers: {Authorization: 'Bearer '+userData.token}
        };
        if (userData.token){
          this.addEmploymentForm.user_type_id = userData['user_type_id'];
          axios.post('user/employments', this.addEmploymentForm,config)
              .then((res) => {
                if (res.status == 200){
                  router.push({ name: 'additional-details'})
                }
              })
              .catch((err) => {
                if (err.response) {
                  console.log(err.response.data.error.message);
                }
              })
        }
      }
    },

    // Getting Current User Employment Details
    getEmployment() {
        var userData = JSON.parse(localStorage.getItem('web_user'));
        var config = {
          headers: {Authorization: 'Bearer '+userData.token}
        };
        if (userData.token){
          axios.get('user/employments/'+userData['id']+'?user_type_id='+userData['user_type_id'],config)
              .then((res) => {
                if (res.status == 200){
                  this.addEmploymentForm = res.data.response
                }
              })
              .catch((err) => {
                if (err.response) {
                  console.log(err.response.data.error.message);
                }
              })
        }
    },
  },
}
</script>

<template>
  <div>
    <Header></Header>
    <div id="main-title" class="secondary">
      <div class="container">
        <div class="row">
          <div class="col-12 col-lg-6 align-self-center">
            <h3 class="title" v-if="userData.is_mentor"> Mentor / Volunteer Details</h3>
            <h3 class="title" v-else>{{ userData['user_type_id'] === 3 ? 'Mentor' : 'Volunteer' }} Details</h3>
          </div>
          <div class="col-12 col-lg-6 text-left text-lg-end align-self-center">
            <p class="need-help">Need Help ? <a href="javascript:">Contact Us</a> </p>
            <!--              <logout-button></logout-button>-->
          </div>
        </div>
      </div>
    </div>
    <div id="create-account">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-12">
            <div class="progress-container">
              <div class="progress-box">
                1
              </div>
              <div class="progress-box">
                2
              </div>
              <div class="progress-box">
                3
              </div>
              <div class="progress-box">
                4
              </div>
              <div class="progress-box active">
                5
              </div>
            </div>
          </div>
        </div>
        <form @submit.prevent="addEmployment" class="custom-form">
          <div class="row">
            <div class="col-12 mb-5">
              <h3 class="main-title">EMPLOYMENT</h3>
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-md-4 mb-4">
              <div class="mb-3">
                <input v-model="addEmploymentForm.employer" type="text" placeholder="Enter Employer" class="form-control" name="employer"
                       :class="{ 'is-invalid': typeSubmit && $v.addEmploymentForm.employer.$error }" />
                <div v-if="typeSubmit && $v.addEmploymentForm.employer.$error" class="invalid-feedback">
                  <span v-if="!$v.addEmploymentForm.employer.required">Employer is required.</span>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-4 mb-4">
              <div class="mb-3">
                <input v-model="addEmploymentForm.city" type="text" placeholder="Enter City Where You Work" class="form-control" name="city"
                       :class="{ 'is-invalid': typeSubmit && $v.addEmploymentForm.city.$error }" />
                <div v-if="typeSubmit && $v.addEmploymentForm.city.$error" class="invalid-feedback">
                  <span v-if="!$v.addEmploymentForm.city.required">City is required.</span>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-4 mb-4">
              <div class="mb-3">
                <input v-model="addEmploymentForm.state" type="text" placeholder="Enter State Where You Work" class="form-control" name="state"
                       :class="{ 'is-invalid': typeSubmit && $v.addEmploymentForm.state.$error }" />
                <div v-if="typeSubmit && $v.addEmploymentForm.state.$error" class="invalid-feedback">
                  <span v-if="!$v.addEmploymentForm.state.required">State is required.</span>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
              <div class="mb-5 col-4 text-md-start"  v-if="backToOverview">
                <b-button type="button" @click="skipToReview" variant="custom">
                  <i class="font-size-20 me-2 bx bxs-right-arrow-circle"></i>
                  Skip To Review
                </b-button>
              </div>
              <div class="mb-4 col-8 text-center text-md-end">
                <b-button type="button" @click="references" variant="custom"><i class="font-size-20 me-2 bx bxs-left-arrow-circle"></i> Back to References</b-button>
                <b-button type="button" @click="addEmployment" variant="custom">Additional Details <i class="font-size-20 ms-2 bx bxs-right-arrow-circle"></i></b-button>
              </div>
          </div>
        </form>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>
